import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Hero from "../../components/Careers/WorkTravel/Hero"
import Ayampe from "../../components/Careers/WorkTravel/Ayampe"
import UniqueExperience from "../../components/Careers/WorkTravel/UniqueExperience"
import Komodo from "../../components/Careers/WorkTravel/Komodo"
import Adventure from "../../components/Careers/WorkTravel/Adventure"

const WorkTravel = () => {
  return (
    <Layout>
      <SEO title="Work & Travel" />
      <Hero />
      <Ayampe />
      <UniqueExperience />
      <Komodo />
      <Adventure />
    </Layout>
  )
}

export default WorkTravel
